<script lang="ts">
  import { Icon } from '@shared/ui/icon';
  import { is } from '@shared/utils';

  export let name: string;
  export let checked = false;
  export let error: string | boolean = false;
  export let disabled = false;

  $: classes = (() => {
    if (error && !checked) return 'border-red-500';
    return is(
      checked,
      'border-default-900 bg-default-900 text-default-50 dark:border-dark-100 dark:bg-dark-100 ',
      'border-default-500 bg-default-50 dark:border-dark-500 dark:bg-dark-200',
    );
  })();
</script>

<label class="flex gap-2">
  <input {name} type="checkbox" class="hidden" bind:checked {disabled} on:change />

  <span class="relative mt-0.5 h-4 min-h-4 w-4 min-w-4 rounded border transition-colors {classes}">
    <Icon
      width="{12}"
      height="{12}"
      classes="absolute inset-0 m-auto transition-opacity {is(checked, 'opacity-100', 'opacity-0')}"
      name="checkMark"
    />
  </span>

  <span class="text-sm {is(error && !checked, 'text-red-500', 'text-default-500 dark:text-dark-600')}">
    <slot />
  </span>
</label>
